<template>
    <div><b>ZenChunk {{item.type}}</b></div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import ZenDataComponent from "./ZenData.vue";

export default {
    name: 'ZenChunkComponent',
    components: {
        ZenDataComponent
    },
    props: [
        'item'
    ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
